import React from 'react';
import { Trans } from 'react-i18next';

import { GetFormatLoanAgreement } from '../../../AppUtil/AppUtil';
import { hot } from 'react-hot-loader';

const trimTheText = text => {
	if (text) {
		return text.trim();
	}
	return '';
};

const LOAN_TYPES = window.AppConfig.LOAN_TYPES;

function Header(props) {
	// NOSONAR
	const loanObject = props.loanObject;
	const borrower = {};
	const lender = {};
	if (loanObject.loan_type === LOAN_TYPES.LEND) {
		if (loanObject.accepted_by === props._currentUserId) {
			lender.name = loanObject.accepted_by_user.name;
			lender.address = trimTheText(loanObject.accepted_by_user.address);
			borrower.state = props.hashedSupportedStates[loanObject.created_by_user.state].name || '';
			borrower.city = loanObject.created_by_user.city ? trimTheText(loanObject.created_by_user.city) : '';
			borrower.postalCode = trimTheText(loanObject.created_by_user.postal_code) || '';
			lender.city = loanObject.accepted_by_user.city ? trimTheText(loanObject.accepted_by_user.city) : '';
			lender.postalCode = trimTheText(loanObject.accepted_by_user.postal_code) || '';
			borrower.name = loanObject.created_by_user.name;
			borrower.address = trimTheText(loanObject.created_by_user.address);
		} else {
			lender.name = loanObject.created_by_user.name;
			lender.address = trimTheText(loanObject.created_by_user.address);
			lender.city = loanObject.created_by_user.city ? trimTheText(loanObject.created_by_user.city) : '';
			lender.postalCode = trimTheText(loanObject.created_by_user.postal_code) || '';
			borrower.state = props.hashedSupportedStates[loanObject.accepted_by_user.state]?.name || '';
			borrower.city = loanObject.accepted_by_user.city ? trimTheText(loanObject.accepted_by_user.city) : '';
			borrower.name = loanObject.accepted_by_user.name;
			borrower.address = trimTheText(loanObject.accepted_by_user.address);
			borrower.postalCode = trimTheText(loanObject.accepted_by_user.postal_code) || '';
		}
	} else {
		if (loanObject.accepted_by === props._currentUserId) {
			lender.name = loanObject.created_by_user.name;
			lender.address = trimTheText(loanObject.created_by_user.address);
			borrower.address = trimTheText(loanObject.accepted_by_user.address);
			borrower.state = props.hashedSupportedStates[loanObject.accepted_by_user.state].name || '';
			borrower.city = loanObject.accepted_by_user.city ? trimTheText(loanObject.accepted_by_user.city) : '';
			lender.city = loanObject.created_by_user.city ? trimTheText(loanObject.created_by_user.city) : '';
			lender.postalCode = trimTheText(loanObject.created_by_user.postal_code) || '';
			borrower.name = loanObject.accepted_by_user.name;
			borrower.postalCode = trimTheText(loanObject.accepted_by_user.postal_code) || '';
		} else {
			lender.name = loanObject.accepted_by_user.name;
			lender.address = trimTheText(loanObject.accepted_by_user.address);
			borrower.state = props.hashedSupportedStates[loanObject.created_by_user.state].name || '';
			borrower.city = loanObject.created_by_user.city ? trimTheText(loanObject.created_by_user.city) : '';
			lender.city = loanObject.accepted_by_user.city ? trimTheText(loanObject.accepted_by_user.city) : '';
			lender.postalCode = trimTheText(loanObject.accepted_by_user.postal_code) || '';
			borrower.name = loanObject.created_by_user.name;
			borrower.address = trimTheText(loanObject.created_by_user.address);
			borrower.postalCode = trimTheText(loanObject.created_by_user.postal_code) || '';
		}
	}
	const start_date = GetFormatLoanAgreement(props.loanObject.start_date);
	const loanID = `LA${String(props.loanObject.id).padStart(5, '0')}`;
	const lender_name = lender.name;

	const lender_address = lender.postalCode
		? lender.address +
		  ' ' +
		  lender.city +
		  ', ' +
		  props.hashedSupportedStates[props.loanObject.lender_state]?.name +
		  ', ' +
		  lender.postalCode
		: lender.address + ' ' + lender.city + ', ' + props.hashedSupportedStates[props.loanObject.lender_state]?.name;

	const borrower_name = borrower.name;
	const borrower_address = borrower.postalCode
		? borrower.address + ' ' + borrower.city + ', ' + borrower.state + ', ' + borrower.postalCode
		: borrower.address + ' ' + borrower.city + ', ' + borrower.state;

	return (
		<>
			<div
				style={{
					width: '100%',
					backgroundColor: '#2196F3',
					padding: '10px',
					margin: '0px auto 20px auto',
					textAlign: 'center'
				}}>
				<img src="/images/LendAmi-Philippines.svg" class="android-logo-image no-print" alt="Logo" />
			</div>
			{props.component}
			<Trans i18nKey="loan_agreement.header">
				<p>
					<strong>KNOW ALL MEN BY THESE PRESENTS</strong>
				</p>
				<p className="justify">
					This Loans Agreement Promissory Note (hereinafter referred to as “Agreement”) for Loan ID{' '}
					<b>{{ loanID }}</b> made and executed on {{ start_date }} at LendAmi by and between:
				</p>
				<p>
					<strong>Parties</strong>
				</p>

				<p className="justify" style={{ paddingLeft: '2rem', paddingRight: '2rem' }}>
					{{ borrower_name }}, Filipino, of legal age and capacity, with residence address at
					{{ borrower_address }} (“the BORROWER”)
				</p>
				<p className="justify" style={{ textAlign: 'center' }}>
					and
				</p>
				<p className="justify" style={{ paddingLeft: '2rem', paddingRight: '2rem' }}>
					{{ lender_name }}, Filipino, of legal age and capacity, with residence address at{' '}
					{{ lender_address }} (“the LENDER”)
				</p>
				<p style={{ textAlign: 'center' }}>(collectively known as the “PARTIES”).</p>
				<p style={{ textAlign: 'center' }}>
					<strong>Recitals</strong>
				</p>
				<p>
					<strong>
						<i>WITNESSETH THAT: </i>
					</strong>
				</p>
				<p className="justify">
					<strong>WHEREAS</strong>, the BORROWER wants to borrow money from the LENDER;
				</p>
				<p className="justify">
					<strong>WHEREAS</strong>, the LENDER has agreed to lend money to the BORROWER subject to the terms
					and conditions in this Agreement;
				</p>
				<p style={{ fontWeight: 'bold' }}>
					<strong>Terms and conditions</strong>
				</p>
				<p className="justify">
					<strong>NOW, THEREFORE</strong>, for and in consideration of the Recitals above and the promises
					that the PARTIES made to each other in this Agreement, they have agreed as follows:
				</p>
			</Trans>
		</>
	);
}

export default hot(module)(Header);
